import { createContext } from 'react';
import { defaultLocale } from './constants';

const LocaleContext = createContext(defaultLocale);

export { LocaleContext };
